import { Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Box } from '@mui/material';
import { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useQuoteState } from 'shared/contexts';
import { ICustomProduct } from 'shared/types';
import { SxProps, Theme } from '@mui/material';
import { CustomProductSummary } from './custom-product-summary';

const rootStyles: SxProps<Theme> = {
  width: '100%',
};
const customProductsStyles: SxProps<Theme> = (theme: Theme) => ({
  marginTop: '20px',
  width: '100%',
  '& .MuiTableRow-head': {
    backgroundColor: theme.palette.background.paper,
  },
  '& .MuiTableCell-head': {
    fontWeight: 'normal',
    '&:nth-of-type(1)': {
      paddingLeft: theme.spacing(5),
    },
  },
});

export function CustomProductDetails() {
  const { newCustomProduct } = useQuoteState();
  const { watch } = useFormContext();
  const { fields, remove, append } = useFieldArray({
    name: 'customProducts',
  });

  const watchExpenses = watch('customProducts') as ICustomProduct[];
  const controlledFields = fields.map((field, index) => ({
    ...field,
    ...watchExpenses?.[index],
  }));

  useEffect(() => {
    if (newCustomProduct) {
      append(newCustomProduct);
    }
  }, [newCustomProduct, append]);

  return (
    <Box sx={rootStyles}>
      <Box sx={customProductsStyles}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align='left'>Product</TableCell>
                <TableCell align='left'>Quantity</TableCell>
                <TableCell align='left'>Price</TableCell>
                <TableCell align='left'>Total Price</TableCell>
                <TableCell align='right' />
              </TableRow>
            </TableHead>
            <TableBody>
              {controlledFields.map((customProduct, index) => (
                <CustomProductSummary
                  key={customProduct.id}
                  customProduct={customProduct}
                  index={index}
                  remove={remove}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}
